import { MATERIALS_URL } from "../../helpers/api.routes";
import { requests } from "../../helpers/api.services";
import { IPagination } from "../../shared/interfaces/shared/IPagination";
import { IMaterial } from "../../shared/interfaces/material/IMaterial";

export const MaterialService = {
  getAll: (params: IPagination) => requests.get(MATERIALS_URL, params),
  create: (params: any) => {
    const isFormData = params instanceof FormData;
    return requests.post(`${MATERIALS_URL}`, params, isFormData);
  },
  getSingle: (id: number) => requests.get(`${MATERIALS_URL}/${id}`),
  update: (params: any, id: number) => {
    const isFormData = params instanceof FormData;
    return requests.put(`${MATERIALS_URL}/${id}`, params, isFormData);
  },
  delete: (id: number) => requests.delete(`${MATERIALS_URL}/${id}`),
  copy: (id: number) => requests.put(`${MATERIALS_URL}/copy/${id}`),
  upload: (formData: FormData) => requests.post(`${MATERIALS_URL}/upload`, formData, true),
};
